






















































































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class CrimeWhen extends GlobalMixins {
	isInitializing: boolean = true
	hasInteractedWithDate: boolean = false

	@Watch('day')
	@Watch('month')
	@Watch('year')
	onDateChange() {
		if (this.isInitializing) return

		this.hasInteractedWithDate = true
		this.checkTimestampValid('setCrimeWhen')
	}

	get title() {
		if (this.$store.getters.user.selectedPunishment === 'no-punishment-yet') {
			return this.pageTexts.crimeWhen.title.noPunishmentYet
		} else if (this.$store.getters.user.selectedPunishment === 'none') {
			return this.pageTexts.crimeWhen.title.noPunishment
		} else {
			return this.pageTexts.crimeWhen.title.punishment
		}
	}
	get description() {
		if (this.$store.getters.user.selectedPunishment === 'no-punishment-yet') {
			return this.pageTexts.crimeWhen.description.noPunishmentYet
		} else if (this.$store.getters.user.selectedPunishment === 'none') {
			return this.pageTexts.crimeWhen.description.noPunishment
		} else {
			return this.pageTexts.crimeWhen.description.punishment
		}
	}
	get descriptionNoHTML() {
		if (this.$store.getters.user.selectedPunishment === 'no-punishment-yet') {
			return this.pageTexts.crimeWhen.descriptionNoHTML.noPunishmentYet
		} else if (this.$store.getters.user.selectedPunishment === 'none') {
			return this.pageTexts.crimeWhen.descriptionNoHTML.noPunishment
		} else {
			return this.pageTexts.crimeWhen.descriptionNoHTML.punishment
		}
	}

	mounted() {
		bus.$emit('setNextButton', false)
		bus.$on('goToNextScreen', () => {
			this.$router.push({ name: this.language === Languages.NL ? 'results' : 'results-'+this.language })
		})

		window.onresize = () => {
			if (!this.windowResizeStagger) {
				this.windowResizeStagger = true
				this.isMobile = window.innerWidth < 768

				setTimeout(() => {
					this.windowResizeStagger = false
				}, 20)
			}
		}

		if (
			this.$store.getters.user.crimeWhen &&
			this.$store.getters.user.crimeWhen !== 'skipped'
		) {
			this.day = this.$store.getters.user.crimeWhen.day
			this.month = this.monthIndexToString(
				this.$store.getters.user.crimeWhen.month
			)
			this.year = this.$store.getters.user.crimeWhen.year
		} else {
			this.day = false
			this.month = this.monthIndexToString(1)
			this.year = 1970
		}

		this.$nextTick(() => {
			this.isInitializing = false
			this.checkTimestampValid('setCrimeWhen')
		})
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}
}
